import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";

class SchoolCalenderStore {
  schoolCalender = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      schoolCalender: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getSchoolCalender: action,
    });
    this.rootStore = rootStore;
  }
  async getCompany({ companyName }) {
    var postData = { name: companyName };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=searchCompany", "postData=" + base64Input);
    console.log(response);
  }
  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;

    var postData = { companyId: companyId };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/schoolCalender/getCalenderList", {
        params: postData,
      });

    this.schoolCalender = response?.data?.data;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async deleteRecord({ calenderId }) {
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/schoolCalender/deleteCalendar", {
        params: {
          calenderId: calenderId,
        },
      });
    return response;
  }

  async addData(postData) {
    var schoolCalenderData = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        config.NodeUrl + "/schoolCalender/updateCalender",
        schoolCalenderData
      );

    return response.data;
  }

  async getSchoolCalender(calendarId) {
    var postData = { calendarId: calendarId, limit: 1, offset: 0 };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/schoolCalender/getCalenderList", {
        params: postData,
      });
    return response.data.data[0];
  }
}

export default SchoolCalenderStore;
